export const environment = {
  apiUrl: '',
  prod: false,
  mercadoPagoPublicKey: 'TEST-f56aee87-3efe-4f12-8b47-8fc6cc506850',
};
